export default "__VITE_ASSET__5daa9204__"